import type { Categoria, EstadoPedido } from '../types'

/** Colores compartidos entre pantallas. Viven aparte de los componentes
 *  para que un cambio de paleta no obligue a tocar varias vistas —y para
 *  que el refresco en caliente siga funcionando en esos archivos. */

export const TONO_ESTADO: Record<EstadoPedido, string> = {
  pendiente: 'bg-ambar-50 text-ambar-600 dark:bg-ambar-500/15 dark:text-ambar-300',
  preparando: 'bg-tinta-50 text-tinta-600 dark:bg-tinta-500/15 dark:text-tinta-200',
  despachada: 'bg-magenta-50 text-magenta-600 dark:bg-magenta-500/15 dark:text-magenta-300',
  entregada: 'bg-lima-50 text-lima-700 dark:bg-lima-500/15 dark:text-lima-300',
  anulada: 'bg-rojo-50 text-rojo-600 dark:bg-rojo-500/15 dark:text-rojo-300',
}

export const TONO_CATEGORIA: Record<Categoria, string> = {
  frutas: 'bg-magenta-50 text-magenta-600 dark:bg-magenta-500/15 dark:text-magenta-300',
  miel: 'bg-ambar-50 text-ambar-600 dark:bg-ambar-500/15 dark:text-ambar-300',
  avena: 'bg-lima-50 text-lima-700 dark:bg-lima-500/15 dark:text-lima-300',
  otros: 'bg-tinta-50 text-tinta-600 dark:bg-tinta-500/15 dark:text-tinta-200',
}

/** El verde de WhatsApp de verdad, con un brillo neón alrededor para que
 *  el botón se note de inmediato —lo mismo que se usa para "poco stock"
 *  pero en el color de la marca. Va todo por `style` (no por clases):
 *  el botón base ya trae su propio fondo y color de texto, y una clase
 *  de Tailwind no siempre le gana a esa —el estilo en línea sí, siempre. */
export const ESTILO_WHATSAPP = {
  borderColor: '#25D366',
  borderWidth: 2,
  backgroundColor: '#eafbf0',
  color: '#0d8a4f',
  boxShadow: '0 0 0 1px rgba(37,211,102,0.35), 0 0 12px 1px rgba(37,211,102,0.65)',
}

/** El celeste de Waze —distinto del "tinta" que usa el resto de la
 *  app, a propósito: así se reconoce de un vistazo cuál es cuál. */
export const ESTILO_WAZE = {
  borderColor: '#33CCFF',
  borderWidth: 2,
  backgroundColor: '#e6f9ff',
  color: '#009DE0',
  boxShadow: '0 0 0 1px rgba(51,204,255,0.3), 0 0 10px 1px rgba(51,204,255,0.55)',
}
